// removed by extract-text-webpack-plugin
module.exports = {"vpElementEditActions":"vpElementEditActions___2Nuad","vpRequiredLabel":"vpRequiredLabel___2ZGiU","vpRequiredSwitchContainer":"vpRequiredSwitchContainer___2BFvx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignEdit/EditActions.module.less
// module id = 3262
// module chunks = 31